import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = [
      'addTestReportCheck',
      'drivingTestReport']
  connect() {
  }

  selectAddDrivingTestReport() {
    // if addTestReportCheck is checked show the drivingTestReport

    if (this.addTestReportCheckTarget.checked) {
      this.drivingTestReportTarget.hidden = false
    } else {
      this.drivingTestReportTarget.hidden = true
    }
  }

}
